export default "__VITE_ASSET__7WMZbV8o__";